export default "__VITE_ASSET__516d8412__"